import { render, staticRenderFns } from "./TwLcArchiveDetailInner.vue?vue&type=template&id=595c566c&scoped=true&"
import script from "./TwLcArchiveDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwLcArchiveDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwLcArchiveDetailInner.vue?vue&type=style&index=0&id=595c566c&lang=scss&scoped=true&"
import style1 from "./TwLcArchiveDetailInner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c566c",
  null
  
)

export default component.exports